import "./Part.css";

function Part({name, isActive, children, isSelected}) {
    
    return ( 
        <div className={"part" + (name ? " " + name : "")}>
            <div className={isActive ? "parent_block active" : "parent_block"} style={ isSelected ? {backgroundColor : 'var(--main)'} : {}}></div>
            {children}
        </div>
    )
}

export default Part;